import React from 'react'
import PropTypes from 'prop-types'

import './Button.scss'

const Button = ({
  className,
  type,
  style,
  color,
  disabled,
  onClick,
  children,
  ...otherProps
}) => {
  const baseClass = 'jv-btn'
  const rootClass = `${baseClass} ${className} ${color}`

  return (
    <button
      className={rootClass}
      style={style}
      type={type}
      disabled={disabled}
      onClick={onClick}
      {...otherProps}
    >{children}</button>
  )
}

Button.defaultProps = {
  style: {},
  className: '',
  color: '',
  type: 'button',
  onClick: null,
  disabled: false
}

Button.propTypes = {
  className: PropTypes.string,
  type: PropTypes.string,
  style: PropTypes.object,
  onClick: PropTypes.func,
  color: PropTypes.string,
  disabled: PropTypes.bool,
  children: PropTypes.node
}

export default Button
